module.exports = __webpack_public_path__ + "static/media/1.97fc17d9.jpg";